module.exports = __webpack_public_path__ + "static/img/enlarge-circular-2.05139f5c.png";